// extracted by mini-css-extract-plugin
module.exports = {"columns":"columns-pEz_JUFaJill3Qx5y9e-N","column":"column-bbJX6hGI0Zf0nGBpjg2fo"};